import { ActionButton } from '../../components/vertical-dot/popper';
import type { CsTransactionHistoryDto } from '../../services/wealthlane-award-settlement-services/services/CsBrokerTradeToolSettlementService';

interface BrokerTradeHistoryHeaderProps {
  actions: Record<string, any>[];
  getHistoryActions: (row: CsTransactionHistoryDto) => any[];
}

interface CellProps {
  row: any;
  cell: any;
}

const BrokerTradeHistoryHeader = ({
  actions,
  getHistoryActions,
}: BrokerTradeHistoryHeaderProps) => {
  const renderActionsCell = ({ row, cell }: CellProps) => {
    const rowData = row?.original as CsTransactionHistoryDto;
    const rowIndex = cell?.row?.index?.toString();

    return (
      <td
        id={`cell.${rowIndex}.actions`}
        style={{
          minWidth: cell.column.minWidth,
          width: cell.column.width,
          textAlign: 'center',
        }}>
        <ActionButton
          actions={getHistoryActions(rowData)}
          id={rowData?.tradeOrderId || rowData?.transactionId}
          counter={rowIndex}
          hideMenuOnActionClick
        />
      </td>
    );
  };

  const newActions = [
    ...(actions || []),
    {
      Header: 'Action',
      accessor: 'actions',
      width: 60,
      sortable: false,
      renderCell: true,
      center: true,
      Cell: renderActionsCell,
    },
  ];

  return newActions;
};

export default BrokerTradeHistoryHeader;
